/** @format */

import React, { FC, useState, useEffect, useMemo } from 'react'
import { _$, Dialog, Table, TableColumn, Button, Tooltip, Icon } from '@king-design/react'
import styled from 'styled-components'
import { TabsListProps } from './constants'
import API from 'src/api/ApiAlarmHistory'
import useFormTable from 'src/hooks/useFormTable'
import { TablePage } from 'src/components'
import { LabelValueItem } from 'src/utils/interface'
import ViewDrawer from 'src/containers/MonitorAlarmSilences/ViewDrawer'
import DeleteConfirm from 'src/components/DeleteConfirm'
const AlarmStateEnum = {
  2: '不满足告警通知时间范围',
  3: '不满足累计告警次数',
  4: '不满足告警通知间隔',
  5: '不满足维度标签'
}

const AlarmEventList: FC<TabsListProps> = ({
  className,
  region,
  dateTime,
  query,
  policyName,
  eventProductList
}) => {
  const [productList, setProductList] = useState<LabelValueItem<string, any>[]>([])
  const [tableGroup, setTableGroup] = useState({
    alarmState: 1,
    productName: 999
  })
  const [receiversVisible, setReceiversVisible] = useState<boolean>(false)
  const [receiversData, setReceiversData] = useState([])
  // const [callbackVisible, setCallbackVisible] = useState<boolean>(false)
  // const [callbackData, setCallbackData] = useState([])
  // 屏蔽规则
  const [shieldVersion, setShieldVersion] = useState<string>('')
  const { run, result, pageState, loading, total } = useFormTable(
    API.getEventHistoryList,
    {
      params: {
        ProductType: tableGroup.productName,
        StartTime: dateTime.StartTime * 1000,
        EndTime: dateTime.EndTime * 1000,
        Region: region,
        InstanceId: query,
        PolicyName: policyName || '',
        AlarmState: tableGroup.alarmState
      },
      manual: true
    },
    data => {
      const { alertList, totalCount } = data
      if (Array.isArray(alertList)) {
        return { tableData: alertList || [], totalCount: totalCount || 0 }
      } else {
        return { tableData: [], totalCount: 0 }
      }
    }
  )

  useEffect(() => {
    const productGroup = [{ label: _$('全部'), value: 999 }]
    if (Array.isArray(eventProductList)) {
      const group = eventProductList.map(item => {
        return { label: item.label, value: item.value }
      })
      setProductList([...productGroup, ...group])
    } else {
      setProductList(productGroup)
    }
  }, [eventProductList])

  useEffect(() => {
    if (dateTime?.StartTime && dateTime?.EndTime && region) {
      run({
        StartTime: dateTime.StartTime * 1000,
        EndTime: dateTime.EndTime * 1000,
        Region: region,
        ProductType: tableGroup.productName,
        InstanceId: query,
        PolicyName: policyName || '',
        AlarmState: tableGroup.alarmState
      })
    }
  }, [dateTime.StartTime, dateTime.EndTime, region, query])

  const tableScheme = useMemo(() => {
    return {
      policyName: _$('策略名称'),
      productName: {
        title: _$('产品类型'),
        group: policyName ? undefined : productList
      },
      eventTitle: _$('告警规则'),
      instanceId: {
        title: _$('关联实例'),
        template: item => (
          <>
            <Tooltip content={`${item.instanceName} (${item.instanceId})`}>
              <span>{item.instanceName}</span>
            </Tooltip>
          </>
        )
      },
      triggerTime: {
        title: _$('时间'),
        template: ({ triggerTime }) => {
          return triggerTime
        }
      },
      alarmState: {
        title: _$('状态'),
        group: [
          { label: _$('全部'), value: 0 },
          { label: _$('已屏蔽'), value: 6 },
          { label: _$('已抑制'), value: 2 },
          { label: _$('已发出'), value: 1 }
        ],
        template: ({ alarmState, shieldVersion }) => {
          return alarmState === 6 ? (
            <a
              onClick={() => {
                setShieldVersion(shieldVersion)
              }}
            >
              {_$('已屏蔽')}
            </a>
          ) : (
            (
              <>
                {alarmState === 1 ? (
                  _$('已发出')
                ) : (
                  <>
                    <p style={{ margin: 0 }}>{_$('已抑制')}</p>
                    <p style={{ margin: 0, color: '#999' }}>{_$(AlarmStateEnum[alarmState])}</p>
                  </>
                )}
              </>
            ) || ''
          )
        }
      },
      alarmReceivers: {
        title: _$('告警联系人'),
        template: ({ alarmReceivers, callBackResult }) => (
          <div className="ksc-space">
            {alarmReceivers?.length ? (
              <a
                className="primary-color"
                onClick={() => {
                  setReceiversData(alarmReceivers || [])
                  setReceiversVisible(true)
                }}
              >
                {_$('联系人')}
              </a>
            ) : null}
            <DeleteConfirm
              title={_$('回调')}
              content={
                <Table data={callBackResult || []} checkType="none">
                  <TableColumn key="callBack" title={_$('回调地址')} />
                  <TableColumn
                    key="result"
                    title={_$('结果')}
                    width={200}
                    slotTemplate={([data]) => {
                      if (data.result === 'success') {
                        return (
                          <div className="ksc-space">
                            <Icon
                              className="ion-checkmark-circled"
                              color="success"
                              style={{ marginRight: '4px' }}
                            />
                            {_$('成功')}
                          </div>
                        )
                      } else if (data.result === '') {
                        return (
                          <div className="ksc-space">
                            <Icon
                              className="k-icon-warning-fill"
                              color="warning"
                              style={{ marginRight: '4px' }}
                            />
                            {_$('未发送')}
                          </div>
                        )
                      } else {
                        return (
                          <div style={{ alignItems: 'flex-start' }} className="ksc-space">
                            <Icon
                              className="k-icon-error-fill"
                              color="danger"
                              style={{ marginRight: '4px' }}
                            />
                            <p style={{ width: '160px', wordBreak: 'break-all' }}>
                              {data.result || ''}
                            </p>
                          </div>
                        )
                      }
                    }}
                  />
                </Table>
              }
            >
              <a>{_$('回调')}</a>
            </DeleteConfirm>
          </div>
        )
      }
    }
    return undefined
  }, [result])

  // 获取事件列表
  // const { value: eventList } = useAsync(async () => {
  //   const result = await GetListSysEvents({
  //     ProductType: 999
  //   })
  //   if (result && result?.code === 'Success' && result?.data.eventList) {
  //     const eventList = result.data.eventList
  //     return eventList
  //   } else {
  //     Message.error(result?.message)
  //     return null
  //   }
  // }, [])
  return (
    <div className={className}>
      {tableScheme ? (
        <TablePage
          tableProps={{
            stickHeader: 50,
            scheme: tableScheme,
            data: result,
            rowKey: row => row.historyId,
            checkType: 'none',
            resizable: true,
            group: tableGroup,
            onChangeGroup: value => {
              setTableGroup(value)
              run({
                PageIndex: 1,
                ProductType: value.productName,
                PolicyName: policyName,
                AlarmState: value.alarmState
              })
            }
          }}
          pageProps={{ total, ...pageState }}
          loading={loading}
          run={run}
        />
      ) : null}
      <Dialog
        value={receiversVisible}
        onClose={() => {
          setReceiversVisible(false)
        }}
        title={_$('告警联系人')}
        slotFooter={
          <React.Fragment>
            <Button type="primary" onClick={() => setReceiversVisible(false)}>
              {_$('关闭')}
            </Button>
          </React.Fragment>
        }
      >
        <Table data={receiversData} checkType="none" resizable={true}>
          <TableColumn key="name" title={_$('姓名')} />
          <TableColumn key="email" title={_$('邮箱')} />
          <TableColumn key="phone" title={_$('电话')} />
        </Table>
      </Dialog>
      {/* <Dialog
        value={callbackVisible}
        onClose={() => {
          setCallbackVisible(false)
        }}
        title={_$('告警回调')}
        slotFooter={
          <React.Fragment>
            <Button type="primary" onClick={() => setCallbackVisible(false)}>
              {_$('关闭')}
            </Button>
          </React.Fragment>
        }
      >
        {callbackData?.length &&
          callbackData.map(item => (
            <p style={{ fontSize: 14 }} key={item}>
              {item}
            </p>
          ))}
      </Dialog> */}
      {/* 查看屏蔽规则 */}
      <ViewDrawer
        visible={!!shieldVersion}
        shieldVersion={shieldVersion}
        onClose={() => {
          setShieldVersion('')
        }}
      />
    </div>
  )
}

export default styled(AlarmEventList)`
  .header {
    display: flex;
    justify-content: space-between;
  }
`
